module.exports = __webpack_public_path__ + "img/suit-6.ba2bff5e.jpg";